import { Configuration, LogLevel, PopupRequest, RedirectRequest } from "@azure/msal-browser";

const state: any = {
  accessToken: null,
  idToken: null,
};

export const loginRequestV1: RedirectRequest = {
  scopes: ["User.ReadWrite"],
  prompt: "none", // Critical for SSO - try silent authentication first
  extraQueryParameters: {
    domain_hint: "organizations", // Optimize for organizational accounts
  },
};

// Fallback login request when silent fails
export const interactiveLoginRequestV1: PopupRequest = {
  scopes: ["User.Read", "openid", "profile", "email"],
  prompt: "select_account", // Allow account selection when interaction is needed
  extraQueryParameters: {
    domain_hint: "organizations",
  },
};

// Silent token request for SSO
export const silentRequestV1 = {
  scopes: ["User.Read"],
  forceRefresh: false, // SSO optimization - use cached tokens when possible
};

// Logout request for proper SSO cleanup
export const logoutRequestV1 = {
  postLogoutRedirectUri: `${window.location.origin}` as string,
  mainWindowRedirectUri: `${window.location.origin}` as string,
};

export const msalConfigV1: Configuration = {
  auth: {
    clientId: window._ENV.REACT_APP_AZURE_CLIENT_ID as string, //,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: `${window.location.origin}` as string,
    postLogoutRedirectUri: `${window.location.origin}` as string,
    navigateToLoginRequestUrl: false, // SSO optimization
  },
  cache: {
    cacheLocation: "localStorage", // Required for SSO across tabs and applications
    storeAuthStateInCookie: true, // Enable for better SSO support
    secureCookies: false, // Set to true in production with HTTPS
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      piiLoggingEnabled: false,
      logLevel: LogLevel.Info,
    },
    windowHashTimeout: 60000,
    iframeHashTimeout: 6000,
    loadFrameTimeout: 0,
    asyncPopups: false, // Better for SSO reliability
  },
};

const authenticationADV1 = {
  run: <P extends { accessToken: string; idToken: string }>(
    tokenResponse: P,
    callback: any
  ) => {
    state.accessToken = tokenResponse.accessToken;
    state.idToken = tokenResponse.idToken;
    callback();
  },
  getAccessToken: () => state.accessToken,
  getIdToken: () => state.idToken,
};

export default authenticationADV1;
